import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { ColorPallet } from "../../../utils/colorPallet";
import { StyledTableCell, StyledTableCell2 } from "../styles";
import { getStatusStyle } from "../../../utils/utils";
import { Roles } from "../../../utils/constants";

interface IProps {
  headers: any;
  data: any;
  Actions?: any;
  profilePictureWidth?: number;
  profilePictureHeight?: number;
  noColumnBorders?: boolean;
  borderCustomColor?: string;
  headerBackgroundColor?: string;
  width?: string;
}

const Index = ({
  headers,
  data,
  Actions,
  profilePictureHeight,
  profilePictureWidth,
  noColumnBorders = false,
  borderCustomColor,
  headerBackgroundColor = "#F0F1F5",
  width = "130px",
}: IProps) => {
  const borderStyle = `1px solid ${
    borderCustomColor ? borderCustomColor : ColorPallet.tableRowBorderColor
  }`;

  return (
    <TableContainer
    sx={{
      maxHeight: {
        xs: 300,
        sm: 400,
        md: 350,
        lg: 600,
        xl: 700,
      },
      "@media (min-width:820px) and (max-width:900px)": {
        maxHeight: 550, 
      },
      "@media (min-width:1023px) and (max-width:1050px)": {
        maxHeight: 210, 
      },
      "@media (min-width:1200px) and (max-width:1280px)": {
        maxHeight: 400, 
      },
    }}
    >
      <Box className="table-width">
        <Table sx={{ border: borderStyle }}
        stickyHeader
        >
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: headerBackgroundColor,
                borderBottom: noColumnBorders ? borderStyle : "none",
              }}
            >
              {headers.map((header: any, index: any) => (
                <StyledTableCell
                  width={
                    header === "Email"
                      ? "200px"
                      : header === "Address"
                      ? "300px"
                      : header === "Name"
                      ? "220px"
                      : header === "Role"
                      ? "150px"
                      : header === "Phone #"
                      ? "200"
                      : ""
                  }
                  key={index}
                  sx={{
                    paddingY: "2px !important",
                    paddingLeft: "8px !important",
                    backgroundColor: headerBackgroundColor,
                    border: noColumnBorders ? "none" : borderStyle,
                  }}
                >
                  {header}
                </StyledTableCell>
              ))}

              {Actions && (
                <StyledTableCell
                  sx={{
                    textAlign: "center",
                    width: width,
                    backgroundColor: headerBackgroundColor,
                    border: noColumnBorders ? "none" : borderStyle,
                  }}
                >
                  Actions
                </StyledTableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.map((row: any, rowIndex: number) => (
              <TableRow
                key={rowIndex}
                sx={{
                  borderBottom: noColumnBorders ? borderStyle : "none",
                  height: "36px",
                  "& td, & th": {
                    padding: "8px",
                    backgroundColor: "transparent",
                    border: noColumnBorders ? "none" : borderStyle,
                  },
                }}
              >
                {headers.map((header: string, colIndex: number) => {
                  const normalizedHeader = header
                    .toLowerCase()
                    .replace(/\s+/g, "_")
                    .replace(/#/g, "number");

                  const possibleKeys = [normalizedHeader];
                  if (normalizedHeader === "phone_number") {
                    possibleKeys.push("contact_number");
                  } else if (normalizedHeader === "role") {
                    possibleKeys.push("role_id");
                  }

                  const cellValue = possibleKeys.find((key) => key in row);

                  return (
                    <StyledTableCell
                      sx={{
                        backgroundColor: "transparent",
                        border: noColumnBorders ? "none" : borderStyle,
                        paddingY: "2px !important",
                        paddingLeft: "8px !important",
                      }}
                      key={colIndex}
                    >
                      {normalizedHeader === "shift_status" ? (
                        <Box
                          sx={{
                            display: "inline-block",
                            padding: "4px 6px",
                            fontSize: "14px",
                            fontWeight: "600",
                            lineHeight: "14px",
                            borderRadius: "4px",
                            backgroundColor: getStatusStyle(row.shift_status)
                              .backgroundColor,
                            color: getStatusStyle(row.shift_status).color,
                          }}
                        >
                          {row.shift_status || "-"}
                        </Box>
                      ) : normalizedHeader === "name" ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          {row.avatar && (
                              <img
                              src={row.avatar}
                              alt={row.name || "Avatar"}
                              style={{
                                width: profilePictureWidth
                                  ? profilePictureWidth
                                  : 15,
                                height: profilePictureHeight
                                  ? profilePictureHeight
                                  : 15,
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          <span>{row.name || "-"}</span>
                        </Box>
                      ) : normalizedHeader === "role" ? (
                        // Map the role_id to its corresponding role name
                        Roles[row.role_id] ? (
                          // Capitalize first letter and leave the rest as is
                          Roles[row.role_id].charAt(0).toUpperCase() +
                          Roles[row.role_id].slice(1).toLowerCase()
                        ) : (
                          "-"
                        )
                      ) : (
                        (cellValue && row[cellValue]) || "-"
                      )}
                    </StyledTableCell>
                  );
                })}
                {Actions && (
                  <>
                    {row.isActive === false ? (
                      <StyledTableCell2
                        sx={{
                          paddingY: "2px !important",
                          paddingLeft: "8px !important",
                        }}
                      >{Actions(row)}</StyledTableCell2>
                    ) : (
                      <StyledTableCell
                        sx={{
                          backgroundColor: "transparent",
                          border: noColumnBorders ? "none" : borderStyle,
                          paddingY: "2px !important",
                          paddingLeft: "8px !important",
                          
                        }}
                      >
                        {Actions(row)}
                      </StyledTableCell>
                    )}
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  );
};

export default Index;
